module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-14-f393ed8fa778a7f19c8ba2a1aeb390df.webp";